import React from 'react';
import { Link } from 'react-router-dom';
import { AlertTriangle } from 'lucide-react';

export default function PaymentCancel() {
  return (
    <div className="min-h-[70vh] grid place-items-center px-6" data-testid="page-payment-cancel">
      <div className="max-w-md w-full am-card p-8 text-center">
        <AlertTriangle className="w-12 h-12 text-amber-400 mx-auto" />
        <h1 className="mt-5 font-display text-4xl uppercase tracking-tight">No worries.</h1>
        <p className="mt-2 text-zinc-400 text-sm">Checkout was cancelled and you weren&rsquo;t charged. Pick your plan whenever you&rsquo;re ready.</p>
        <div className="mt-6 flex flex-col gap-2">
          <Link to="/pricing" className="bg-[#ff2a2a] hover:bg-[#e01f1f] text-white text-sm font-semibold py-3 transition-colors" data-testid="cancel-back-pricing">Back to Pricing</Link>
          <Link to="/" className="hairline hover:border-[#ff2a2a] text-white text-sm font-semibold py-3 transition-colors" data-testid="cancel-home">Back to Home</Link>
        </div>
      </div>
    </div>
  );
}
